import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Calendar, User, ArrowRight, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

const Blog = () => {
  const { i18n } = useTranslation();

  const content = {
    fr: {
      title: 'Actualités',
      subtitle: "Dernières nouvelles du Marathon de l'Avenir EDENLIFE 2026",
      readMore: 'Lire la suite',
      articles: [
        {
          id: 1,
          title: "Lancement officiel du Marathon de l'Avenir EDENLIFE 2026",
          excerpt: "Nous sommes ravis d'annoncer le lancement officiel de notre plus grande initiative de collecte de fonds. Découvrez les 3 prix extraordinaires à gagner...",
          date: '15 Décembre 2025',
          author: 'Équipe EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Annonce'
        },
        {
          id: 2,
          title: 'Impact de nos projets en Haïti',
          excerpt: 'Grâce à votre générosité, nous avons déjà installé des systèmes solaires dans 50 foyers et formé 100 agriculteurs aux techniques modernes...',
          date: '10 Décembre 2025',
          author: 'Marie Jean-Baptiste',
          image: '/logo-marathon-2026.png',
          category: 'Impact'
        },
        {
          id: 3,
          title: 'Comment fonctionne le tirage au sort ?',
          excerpt: 'Découvrez le processus transparent et sécurisé de notre tirage au sort. Chaque billet a une chance égale de gagner...',
          date: '5 Décembre 2025',
          author: 'Équipe EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Guide'
        },
        {
          id: 4,
          title: 'Témoignage : Une famille transformée',
          excerpt: 'La famille Dupont partage son expérience après avoir bénéficié d\'un de nos projets d\'énergie solaire...',
          date: '1 Décembre 2025',
          author: 'Pierre Dupont',
          image: '/logo-marathon-2026.png',
          category: 'Témoignage'
        }
      ]
    },
    en: {
      title: 'News',
      subtitle: 'Latest news from the EDENLIFE Marathon 2026',
      readMore: 'Read more',
      articles: [
        {
          id: 1,
          title: 'Official Launch of EDENLIFE Marathon 2026',
          excerpt: 'We are excited to announce the official launch of our largest fundraising initiative. Discover the 3 extraordinary prizes to win...',
          date: 'December 15, 2025',
          author: 'EDENLIFE Team',
          image: '/logo-marathon-2026.png',
          category: 'Announcement'
        },
        {
          id: 2,
          title: 'Impact of Our Projects in Haiti',
          excerpt: 'Thanks to your generosity, we have already installed solar systems in 50 homes and trained 100 farmers in modern techniques...',
          date: 'December 10, 2025',
          author: 'Marie Jean-Baptiste',
          image: '/logo-marathon-2026.png',
          category: 'Impact'
        },
        {
          id: 3,
          title: 'How Does the Draw Work?',
          excerpt: 'Discover the transparent and secure process of our draw. Each ticket has an equal chance of winning...',
          date: 'December 5, 2025',
          author: 'EDENLIFE Team',
          image: '/logo-marathon-2026.png',
          category: 'Guide'
        },
        {
          id: 4,
          title: 'Testimonial: A Transformed Family',
          excerpt: 'The Dupont family shares their experience after benefiting from one of our solar energy projects...',
          date: 'December 1, 2025',
          author: 'Pierre Dupont',
          image: '/logo-marathon-2026.png',
          category: 'Testimonial'
        }
      ]
    },
    ht: {
      title: 'Nouvèl',
      subtitle: 'Dènye nouvèl sou Maraton EDENLIFE Entènasyonal 2026',
      readMore: 'Li plis',
      articles: [
        {
          id: 1,
          title: 'Lansman ofisyèl Maraton EDENLIFE 2026',
          excerpt: 'Nou kontan annonse lansman ofisyèl pi gwo inisyativ kolèk fon nou an. Dekouvri 3 pri ekstraòdinè pou genyen...',
          date: '15 Desanm 2025',
          author: 'Ekip EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Anons'
        },
        {
          id: 2,
          title: 'Enpak pwojè nou yo an Ayiti',
          excerpt: 'Gras a jenerozite ou, nou deja enstale sistèm solè nan 50 kay epi fòme 100 kiltivatè nan teknik modèn...',
          date: '10 Desanm 2025',
          author: 'Marie Jean-Baptiste',
          image: '/logo-marathon-2026.png',
          category: 'Enpak'
        },
        {
          id: 3,
          title: 'Kijan tiraj la fèt?',
          excerpt: 'Dekouvri pwosesis transparan ak sekirize tiraj la. Chak tikè gen menm chans pou genyen...',
          date: '5 Desanm 2025',
          author: 'Ekip EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Gid'
        },
        {
          id: 4,
          title: 'Temwayaj: Yon fanmi transfòme',
          excerpt: 'Fanmi Dupont pataje eksperyans yo apre yo te benefisye de youn nan pwojè enèji solè nou yo...',
          date: '1 Desanm 2025',
          author: 'Pierre Dupont',
          image: '/logo-marathon-2026.png',
          category: 'Temwayaj'
        }
      ]
    },
    es: {
      title: 'Noticias',
      subtitle: 'Últimas noticias del Maratón EDENLIFE 2026',
      readMore: 'Leer más',
      articles: [
        {
          id: 1,
          title: 'Lanzamiento oficial del Maratón EDENLIFE 2026',
          excerpt: 'Estamos emocionados de anunciar el lanzamiento oficial de nuestra mayor iniciativa de recaudación de fondos. Descubre los 5 premios extraordinarios a ganar...',
          date: '15 de Diciembre 2025',
          author: 'Equipo EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Anuncio'
        },
        {
          id: 2,
          title: 'Impacto de nuestros proyectos en Haití',
          excerpt: 'Gracias a tu generosidad, ya hemos instalado sistemas solares en 50 hogares y capacitado a 100 agricultores en técnicas modernas...',
          date: '10 de Diciembre 2025',
          author: 'Marie Jean-Baptiste',
          image: '/logo-marathon-2026.png',
          category: 'Impacto'
        },
        {
          id: 3,
          title: '¿Cómo funciona el sorteo?',
          excerpt: 'Descubre el proceso transparente y seguro de nuestro sorteo. Cada boleto tiene la misma oportunidad de ganar...',
          date: '5 de Diciembre 2025',
          author: 'Equipo EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Guía'
        },
        {
          id: 4,
          title: 'Testimonio: Una familia transformada',
          excerpt: 'La familia Dupont comparte su experiencia después de beneficiarse de uno de nuestros proyectos de energía solar...',
          date: '1 de Diciembre 2025',
          author: 'Pierre Dupont',
          image: '/logo-marathon-2026.png',
          category: 'Testimonio'
        }
      ]
    },
    pt: {
      title: 'Notícias',
      subtitle: 'Últimas notícias da Maratona EDENLIFE 2026',
      readMore: 'Leia mais',
      articles: [
        {
          id: 1,
          title: 'Lançamento oficial da Maratona EDENLIFE 2026',
          excerpt: 'Estamos entusiasmados em anunciar o lançamento oficial da nossa maior iniciativa de arrecadação de fundos. Descubra os 5 prêmios extraordinários a ganhar...',
          date: '15 de Dezembro 2025',
          author: 'Equipe EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Anúncio'
        },
        {
          id: 2,
          title: 'Impacto dos nossos projetos no Haiti',
          excerpt: 'Graças à sua generosidade, já instalamos sistemas solares em 50 lares e treinamos 100 agricultores em técnicas modernas...',
          date: '10 de Dezembro 2025',
          author: 'Marie Jean-Baptiste',
          image: '/logo-marathon-2026.png',
          category: 'Impacto'
        },
        {
          id: 3,
          title: 'Como funciona o sorteio?',
          excerpt: 'Descubra o processo transparente e seguro do nosso sorteio. Cada bilhete tem a mesma chance de ganhar...',
          date: '5 de Dezembro 2025',
          author: 'Equipe EDENLIFE',
          image: '/logo-marathon-2026.png',
          category: 'Guia'
        },
        {
          id: 4,
          title: 'Depoimento: Uma família transformada',
          excerpt: 'A família Dupont compartilha sua experiência após se beneficiar de um dos nossos projetos de energia solar...',
          date: '1 de Dezembro 2025',
          author: 'Pierre Dupont',
          image: '/logo-marathon-2026.png',
          category: 'Depoimento'
        }
      ]
    }
  };

  const t = content[i18n.language] || content.fr;

  return (
    <div className="min-h-screen pt-24 px-6 pb-12" style={{ background: 'linear-gradient(135deg, #F4F1DE 0%, #E8E3D3 100%)' }}>
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="text-center mb-12">
            <BookOpen className="w-20 h-20 text-primary mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              {t.title}
            </h1>
            <p className="text-lg text-gray-600">{t.subtitle}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {t.articles.map((article, index) => (
              <motion.article
                key={article.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/90 backdrop-blur-md rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
              >
                <div className="h-48 bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center">
                  <img src={article.image} alt="" className="h-20 w-auto opacity-50" />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-3 py-1 bg-secondary/10 text-secondary text-sm font-medium rounded-full">
                      {article.category}
                    </span>
                    <div className="flex items-center text-gray-500 text-sm">
                      <Calendar className="w-4 h-4 mr-1" />
                      {article.date}
                    </div>
                  </div>
                  <h2 className="text-xl font-bold text-primary mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {article.title}
                  </h2>
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-gray-500 text-sm">
                      <User className="w-4 h-4 mr-1" />
                      {article.author}
                    </div>
                    <button className="flex items-center text-primary font-medium hover:text-secondary transition-colors">
                      {t.readMore}
                      <ArrowRight className="w-4 h-4 ml-1" />
                    </button>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Blog;